<template>
  <div id="app">
    <router-view/>
  </div>
</template>


<script>
import DevicePixelRatio from './utils/devicePixelRatio'

export default {
  created(){
    new DevicePixelRatio().init()
  }
}
</script>


<style lang="scss">
   @import url(./assets/font/iconfont.css);
</style>
